import { render, staticRenderFns } from "./DatabaseConnections.vue?vue&type=template&id=45105ebb&"
import script from "./DatabaseConnections.vue?vue&type=script&lang=js&"
export * from "./DatabaseConnections.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports